import { api } from '@shared/services/api/axios';

export const configureAuthInterceptor = (getToken: () => Promise<string | null>) => {
  // Remover interceptores existentes para evitar duplicados
  api.interceptors.request.eject(0);
  api.interceptors.response.eject(0);

  const requestInterceptor = api.interceptors.request.use(
    async (config) => {
      try {
        const token = await getToken();
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        
        return config;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const responseInterceptor = api.interceptors.response.use(
    (response) => response,
    (error) => {
      // Manejo centralizado de errores de autenticación
      const errorMsg = error?.response?.data?.error || error?.response?.data?.message || '';
      const isCallbackUrlError = errorMsg.includes('Callback URL mismatch');
      const isAuthError = error?.response?.status === 401 || error?.response?.status === 403;
      const isOnCallbackPage = typeof window !== 'undefined' && window.location.pathname === '/callback';

      // No redirigir a /login desde la página de callback: evita bucle login -> Auth0 -> callback -> 401 -> /login -> auto login() -> ...
      // La página Callback maneja el error y puede navegar a /login con state para no auto-disparar login de nuevo.
      if (isOnCallbackPage) {
        return Promise.reject(error);
      }

      if (isCallbackUrlError) {
        window.location.href = '/login';
      } else if (isAuthError) {
        window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  );

  return () => {
    // Función de limpieza para remover los interceptores
    api.interceptors.request.eject(requestInterceptor);
    api.interceptors.response.eject(responseInterceptor);
  };
}; 